import url from './url';



export default url(() => '/popups');
